module.exports = __webpack_public_path__ + "static/media/server_error.a837881d.svg";